var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1727_30519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18C10 13.5817 13.5817 10 18 10H34C38.4183 10 42 13.5817 42 18V42H18C13.5817 42 10 38.4183 10 34V18Z",
    fill: "url(#paint0_linear_1727_30519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18C10 13.5817 13.5817 10 18 10H34C38.4183 10 42 13.5817 42 18V42H18C13.5817 42 10 38.4183 10 34V18Z",
    fill: "url(#paint1_linear_1727_30519)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7003 21.1469L29.9714 18.418C29.1358 17.5824 28.0069 17.1113 26.8247 17.1113H22.4425C19.7758 17.1113 17.998 18.8891 17.998 21.5558V30.4447C17.998 33.1113 19.7758 34.8891 22.4425 34.8891H29.5536C32.2203 34.8891 33.998 33.1113 33.998 30.4447V24.2847C33.998 23.1024 33.5269 21.9735 32.7003 21.1469Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5527 27.1117V23.7783H24.2194C22.7527 23.7783 21.5527 24.9783 21.5527 26.445V27.3339H25.3305C25.455 27.3339 25.5527 27.2361 25.5527 27.1117Z",
    fill: "#F15836"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6656 27.3339H30.4434V26.445C30.4434 24.9783 29.2434 23.7783 27.7767 23.7783H26.4434V27.1117C26.4434 27.2361 26.5411 27.3339 26.6656 27.3339Z",
    fill: "#F15836"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3305 28.2227H21.5527V29.1115C21.5527 30.5782 22.7527 31.7782 24.2194 31.7782H25.5527V28.4449C25.5527 28.3204 25.455 28.2227 25.3305 28.2227Z",
    fill: "#F15836"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4434 28.4449V31.7782H27.7767C29.2434 31.7782 30.4434 30.5782 30.4434 29.1115V28.2227H26.6656C26.5411 28.2227 26.4434 28.3204 26.4434 28.4449Z",
    fill: "#F15836"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1727_30519",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.429333 0 0 0 0 0.108333 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1727_30519"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1727_30519",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1727_30519",
    x1: 28.6531,
    y1: 41.6814,
    x2: 28.3401,
    y2: 8.82096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1727_30519",
    x1: 28.2593,
    y1: 42,
    x2: 28.0619,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF45"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSim);
export default __webpack_public_path__ + "static/media/sim.62924f8e48333877588634b4412be4bd.svg";
export { ForwardRef as ReactComponent };